export default {
  title: 'Activează notificările pentru oferte exclusive & actualizări',
  description:
    'Primește actualizări ale comenzilor în timp real. Urmărește statusul livrării. Promoții și beneficii exclusive.',
  buttons: {
    confirm: 'Activează',
    cancel: 'Nu acum',
  },
};
